import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { CriterionsService } from '../../services/criterions.service';

@Component({
  selector: 'app-criterion-decision',
  templateUrl: './criterion-decision.component.html',
  styleUrls: ['./criterion-decision.component.scss']
})
export class CriterionDecisionComponent extends BaseComponent implements OnInit {
  criterion$ = this.criterionsService.criterion$;
  decisionInputs$ = this.criterionsService.decisionInputs$;

  constructor(private criterionsService: CriterionsService) { super(); }

  ngOnInit() {
  }

}
